import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useTrans } from "../../hooks";

import { ConnectImage, Icon, Modal, MODAL_ID } from "../../shared-components";
import { Button, ButtonVariant } from "@wattpad/web-ui-library";
import formatScheduledPartDate from "../../../helpers/format-scheduled-part-date";

const ScheduleSuccessModal = ({
  storyId,
  partId,
  title,
  scheduledPublishDatetime,
  showModal,
  onClose
}) => {
  const modalRef = useRef();
  const { trans } = useTrans();

  const handleChangeSchedule = () => {
    modalRef.current.hide();

    window?.wattpad?.utils.redirectWithParams(
      `/myworks/${storyId}/write/${partId}`,
      { triggerPublishingScheduler: true }
    );
  };

  const handleContinue = () => {
    modalRef.current.hide();
  };

  return (
    <Modal
      id={MODAL_ID.SCHEDULE_SUCCESS_MODAL_ID}
      {...{ showModal, onClose }}
      ref={modalRef}
    >
      <header className="schedule-success-modal-header">
        <ConnectImage
          name={`writer/schedule-part-confirmation-success@3x.png`}
        />
        <h2 className="modal-title">{trans("Your part is scheduled!")}</h2>
      </header>

      <div className="schedule-success-modal-content">
        <ul className="schedule-success-steps">
          <li className="active-step">
            <div className="active-check-icon">
              {<Icon name="check" color="wp-neutral-5" size={18} />}
            </div>
            <span
              dangerouslySetInnerHTML={{
                __html: trans(
                  "You’ve scheduled %s to publish later",
                  `<span class="story-title">${title}</span>`
                )
              }}
            />
          </li>
          <li>{trans("Let your readers know your next part is coming")}</li>
          <li className="publish-date-step">
            <span
              dangerouslySetInnerHTML={{
                __html: trans(
                  "We’ll publish your part automatically on %s",
                  `<span class="scheduled-date">${formatScheduledPartDate(
                    scheduledPublishDatetime
                  )}</span>`
                )
              }}
            />
          </li>
        </ul>

        <div className="schedule-success-footer">
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={handleChangeSchedule}
          >
            <Icon
              name="calendar"
              size="20"
              color="ds-neutral-00-solid"
              className="calendar-icon"
            />
            {trans("Change schedule")}
          </Button>

          <Button variant={ButtonVariant.SECONDARY} onClick={handleContinue}>
            {trans("Continue")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ScheduleSuccessModal.propTypes = {
  storyId: PropTypes.string,
  partId: PropTypes.number,
  title: PropTypes.string,
  scheduledPublishDatetime: PropTypes.string,
  showModal: PropTypes.bool,
  onClose: PropTypes.func
};

export default ScheduleSuccessModal;
